import { DomainError } from '../errors.js';
import { SIDE_KINDS } from './next-operation.js';
import type { SequenceReport } from './sequence.js';

/**
 * Sefer raporunu kaldırma (taslaktan vazgeçme) ve gerekçeli iptal (ADR 0077 §3): yalnız seferin
 * son akış raporu. Sıra kuralları (`sequence.ts`) ve Next Operation kilidi (ADR 0057 §5) her
 * raporu kendinden öncekine bağlar; ortadaki rapor kalkarsa sonraki raporun dayandığı seçim ve
 * açık çift değişir. Son raporu kaldırmak geçerli dizinin önekini bırakır, o da geçerlidir. Yan
 * olaylar (yük, kiralama) akışın dışındadır: her zaman kaldırılır, akışı da kilitlemez.
 *
 * `reports`: seferin silinmemiş ve iptal edilmemiş raporları (taslaklar dahil).
 */
export function laterFlowReports(reports: readonly SequenceReport[], id: string): SequenceReport[] {
  const target = reports.find((r) => r.id === id);
  if (!target || SIDE_KINDS.has(target.kind)) return [];
  const at = Date.parse(target.reportedAt);
  return reports.filter((r) => {
    if (r.id === id || SIDE_KINDS.has(r.kind)) return false;
    const time = Date.parse(r.reportedAt);
    // Aynı anda sıra kimliktir (listeler `reported_at`, `id` sırasıyla okunur)
    return time > at || (time === at && r.id > id);
  });
}

export function reportRemovable(reports: readonly SequenceReport[], id: string): boolean {
  return laterFlowReports(reports, id).length === 0;
}

/** Sonrasında akış raporu olan rapor kaldırılamaz ve iptal edilemez (`REPORT_NOT_LAST`). */
export function assertReportRemovable(reports: readonly SequenceReport[], id: string): void {
  const later = laterFlowReports(reports, id);
  if (later.length > 0) {
    throw new DomainError('REPORT_NOT_LAST', later.map((r) => r.id).join(','));
  }
}
